import React, { useState } from "react";

// Chakra imports
import {
  Checkbox,
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Icon,
  useDisclosure,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import {
  MdOutlineMoreHoriz,
  MdOutlinePerson,
  MdOutlineCardTravel,
  MdOutlineLightbulb,
  MdOutlineSettings,
} from "react-icons/md";

export default function Banner(props) {
  const { extraFilter, setExtraFilter, ...rest } = props;

  const handleCheckboxChange = (status) => {
    if (extraFilter.includes(status)) {
      setExtraFilter(extraFilter.filter((s) => s !== status));
    } else {
      setExtraFilter([status]);
    }
    //console.log(extraFilter);
  };

  const textColor = useColorModeValue("secondaryGray.500", "white");
  const textHover = useColorModeValue(
    { color: "secondaryGray.900", bg: "unset" },
    { color: "secondaryGray.500", bg: "unset" }
  );
  const iconColor = useColorModeValue("brand.500", "white");
  const bgList = useColorModeValue("white", "whiteAlpha.100");
  const bgShadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  // Ellipsis modals
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();

  return (
    <Menu isOpen={isOpen1} onClose={onClose1}>
      <MenuButton
        align='center'
        justifyContent='center'
        bg={bgButton}
        _hover={bgHover}
        _focus={bgFocus}
        _active={bgFocus}
        w='37px'
        h='37px'
        lineHeight='100%'
        onClick={onOpen1}
        borderRadius='10px'
        {...rest}>
        <Icon as={MdOutlineMoreHoriz} color={iconColor} w='24px' h='24px' />
      </MenuButton>
      <MenuList
        w='150px'
        minW='unset'
        maxW='150px !important'
        border='transparent'
        backdropFilter='blur(63px)'
        bg={bgList}
        boxShadow={bgShadow}
        borderRadius='20px'
        p='15px'>
        <MenuItem
          transition='0.2s linear'
          color={textColor}
          _hover={textHover}
          p='0px'
          borderRadius='8px'
          _active={{
            bg: "transparent",
          }}
          _focus={{
            bg: "transparent",
          }}
          mb='10px'>
          <Flex align='center'>
            <Checkbox
              isChecked={extraFilter.includes(1)}
              onChange={() => handleCheckboxChange(1)}
            >
              <Text fontSize='sm' fontWeight='400'>
                Official Seller
              </Text>
            </Checkbox>
          </Flex>
        </MenuItem>
        <MenuItem
          transition='0.2s linear'
          color={textColor}
          _hover={textHover}
          p='0px'
          borderRadius='8px'
          _active={{
            bg: "transparent",
          }}
          _focus={{
            bg: "transparent",
          }}>
          <Flex align='center'>
            <Checkbox
              isChecked={extraFilter.includes(4)}
              onChange={() => handleCheckboxChange(4)}
            >
              <Text fontSize='sm' fontWeight='400' mb="10px">
                Suspicious seller
              </Text>
            </Checkbox>
          </Flex>
        </MenuItem>
        <hr />
        <MenuItem
          transition='0.2s linear'
          p='0px'
          borderRadius='8px'
          color={textColor}
          _hover={textHover}
          _active={{
            bg: "transparent",
          }}
          _focus={{
            bg: "transparent",
          }}
          mb='10px'>
          <Flex align='center'>
            <Checkbox
              isChecked={extraFilter.includes(2)}
              onChange={() => handleCheckboxChange(2)}
            >
              <Text fontSize='sm' fontWeight='400'>
                Genuine Purchase
              </Text>
            </Checkbox>
          </Flex>
        </MenuItem>
        <MenuItem
          transition='0.2s linear'
          p='0px'
          borderRadius='8px'
          color={textColor}
          _hover={textHover}
          _active={{
            bg: "transparent",
          }}
          _focus={{
            bg: "transparent",
          }}
          mb='10px'>
          <Flex align='center'>
            <Checkbox
              isChecked={extraFilter.includes(3)}
              onChange={() => handleCheckboxChange(3)}
            >
              <Text fontSize='sm' fontWeight='400'>
                Counterfeit Purchase
              </Text>
            </Checkbox>
          </Flex>
        </MenuItem>

        <MenuItem
          transition='0.2s linear'
          color={textColor}
          _hover={textHover}
          p='0px'
          borderRadius='8px'
          _active={{
            bg: "transparent",
          }}
          _focus={{
            bg: "transparent",
          }}>
          <Flex align='center'>
            <Checkbox
              isChecked={extraFilter.includes(5)}
              onChange={() => handleCheckboxChange(5)}
            >
              <Text fontSize='sm' fontWeight='400'>
                Yet to be tested
              </Text>
            </Checkbox>
          </Flex>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
